
/**
 * Custom hook for tracking analytics events
 */
export const useAnalytics = () => {
  /**
   * Track a custom event
   */
  const trackEvent = (
    eventName: string,
    eventParams?: Record<string, any>
  ) => {
    // Make sure window and gtag are defined
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', eventName, eventParams);
    }
  };

  /**
   * Track a page view
   */
  const trackPageView = (
    pagePath: string,
    pageTitle?: string
  ) => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('config', 'G-DV6YKBMWVT', {
        page_path: pagePath,
        page_title: pageTitle
      });
    }
  };

  return {
    trackEvent,
    trackPageView,
  };
};
